export enum DataFillValueType {
  Text = 0,
  Integer = 1,
  Decimal = 2,
  Boolean = 3,
  Date = 4,
  Catalogue = 5,
}
